// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-map[data-v-0c1c87fa] {\n  height: inherit;\n  width: inherit;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
